module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_02@2x-976765e6ba1daf316cddc46eaa9e87d2.webp";